<template>
  <div class="container-fluid h-100">
    <div class="content-promo-club" id="content-club" title="motera havoline moto club" alt="motera havoline moto club">
      <div
        class="row jusify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100 ">
        <div class="col-12 col-md-8 col-lg-8 col-xl-8 col-sm-8">
          <h1 class="participa">
            ¡BIENVENIDO A HAVOLINE
            MOTOCLUB TE CUBRE!
          </h1>
        </div>
        <div class="mb-4 col-12 col-md-8 col-lg-8 col-xl-8 col-sm-8">
          <p class="text-club mt-2">
            ¡Hola! Bienvenido a Havoline Motoclub Te Cubre, un club de fidelización pensado
            y creado para cubrir las necesidades de los moteros cuando ruedan.
          </p>
          <p class="text-club mt-5">
            Ser parte del club es muy fácil, solo tienes que registrar en nuestra página web
            (Tranquilo, tus datos estarán 100% seguros con nosotros).
          </p>
          <p class="text-club mt-5">
            Una vez registrado, podrás empezar a inscribir los códigos que encontrás en los
            productos Havoline 4T y complementarios para motos, y cambiarlos por increíbles
            beneficios como:
          </p>
        </div>
        <div class="col-12 col-md-9 col-lg-9 col-xl-6 col-sm-6 mt-5">
          <div class="row">
            <div class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-4">
              <img class="image" @click="showPopUp()" alt="bonos" width="130" height="120" src="./../../assets/icon/Bonos.png">
              <p class="text-icon">BONOS</p>
            </div>  
            <div class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-4">
              <img class="image" @click="showPopUp()" alt="herramienta" width="120" height="120" src="./../../assets/icon/Herramientas.png">
              <p class="text-icon">HERRAMIENTAS</p>
            </div>  
            <div class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-4">
              <img class="image" @click="showPopUp()" alt="accesorios" width="120" height="125" src="./../../assets/icon/Accesorios.png">
              <p class="text-icon">ACCESORIOS</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal para escoger catálogo -->
      <div
        class="modal fade"
        id="modalDecision"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal_content_popup">
            <div class="content_close">
              <img
                src="../../assets/icon/icon_close.png"
                width="20"
                title="cerrar popup"
                alt="cerrar popup"
                @click="closedModal()"
              />
            </div>
            <div class="modal-header">
              <h5
                class="modal-title"
                id="exampleModalLabel"
                style="color:#6c757d; margin:auto;"
              >
                Elige el tipo de catálogo que deseas ver
              </h5>
            </div>
            <div style="margin:auto;" class="modal-footer">
              <button
                @click="GoCatalogueBik()"
                type="button"
                class="btn btn-danger btn-sm"
              >
                Catálogo Motero
              </button>
              <button
                @click="GoCatalogueLub()"
                type="button"
                class="btn btn-danger btn-sm"
                >
                Catálogo Lubricador
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import $ from "jquery";

  export default {
    data(){
      return {
        user: null
      };
    },
    methods: {
      getUser(){
        axios
        .get('api/showUser')
        .then((res) => {
          if(res.data.ResponseCode == 0){
            this.user = res.data.User;
            // console.log(JSON.stringify(this.user));
          } else {
            this.user = null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      },
      showPopUp(){
        if(this.user != null){
          if(this.user.role_id == 4){
            this.$router.push({ name: "catalogueLub1" });
          }
          else if(this.user.role_id == 5){
            this.$router.push({ name: "catalogue1" });
          }
        } else {
          $("#modalDecision").modal("show");
        }
      },
      closedModal(){
        $("#modalDecision").modal("hide");
      },
      GoCatalogueBik(){
        $("#modalDecision").modal("hide");
        this.$router.push({ name: "catalogue" });
      },
      GoCatalogueLub(){
        $("#modalDecision").modal("hide");
        this.$router.push({ name: "catalogueLub" });
      },
    },
    mounted(){
      this.getUser();
    },
  }
</script>

<style scoped>
.text-icon{
  padding-top: 10px;
  font-size: 15px;
  color: #FBBC04;
  font-family: 'Gotham-UltraItalic', sans-serif;
}
.img-etiqueta {
  width: 100px;
  height: 100px;
}
.image{
  cursor: pointer;
}
.participa {
  font-size: 50px;
  font-family: 'Gotham-UltraItalic', sans-serif;
  padding-bottom: 4%;
}
.etiqueta {
  font-family: "GothamBookItalic", sans-serif;
}
.small-size {
  font-family: "GothamBookItalic", sans-serif !important;
}
.actual {
  padding-left: 20%;
  font-family: "GothamBoldItalic", sans-serif;
  font-size: 29px;
}
.oportunidades {
  font-size: 20px;
  font-family: "GothamBoldItalic", sans-serif;
  margin-bottom: 0rem !important;
}
.text-club {
  font-size: 20px;
  margin-bottom: 0rem !important;
  font-family: "GothamBoldItalic", sans-serif;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.content-promo-club {
  padding-top: 10%;
  padding-bottom: 6%;
  height: 100%;
}
#content-club {
  background-size: cover;
  background-image: url("./../../assets/img/FOTO-1.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.modal_content_popup{
  padding: 10px 20px 20px 20px;
  max-width: 95%;
  margin: auto;
  box-shadow: 0px 0px 20px black;
}
.content_close{
  margin: auto 0px auto auto;
  cursor: pointer;
  font-weight: bold;
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* MOBILE */
@media (max-width: 767px) {
  .participa {
    font-size: 40px;
    /* padding-bottom: 4%; */
  }
  .content-promo-club {
    padding-top: 35%;
    padding-bottom: 12%;
    height: 100%;
  }
  .text-icon{
    padding-bottom: 20px;
  } 
  .text-club {
    text-align: center;
    font-size: 20px;
    padding-left: 0%;
  }
}
</style>